var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircledTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8322 0.0104179 31.9896 7.16776 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16ZM2.90906 15.9998C2.90906 23.2297 8.77006 29.0907 16 29.0907C23.2266 29.0827 29.0829 23.2264 29.0909 15.9998C29.0909 8.76986 23.2299 2.90886 16 2.90886C8.77006 2.90886 2.90906 8.76986 2.90906 15.9998Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M20.7899 11.3351L14.5456 17.5794L11.2103 14.2442C10.8451 13.866 10.3043 13.7144 9.79574 13.8475C9.28718 13.9806 8.89003 14.3778 8.75691 14.8863C8.6238 15.3949 8.77545 15.9357 9.15356 16.3009L13.5172 20.6645C14.0852 21.2323 15.0059 21.2323 15.5739 20.6645L22.8467 13.3918C23.3979 12.8211 23.39 11.9139 22.8289 11.3528C22.2679 10.7917 21.3607 10.7838 20.7899 11.3351Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircledTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circledTick.4f3527f65c907144cae86091185df6ad.svg";